import { Component, OnInit } from '@angular/core';
import { ConfirmationModalComponent } from '../../shared/modals/confirmation-modal/confirmation-modal.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { AgilityRiskService } from '../../../providers/agility-risk.service';
import { TemplateAccess } from '../../../models/template-access';
import { AgilityRiskMessageService } from '../../../providers/agility-risk-message.service';
import { AgilityRiskSpinnerService } from '../../../providers/agility-risk-spinner.service';
import { RiskTemplatesListComponent } from './modals/risk-templates-list/risk-templates-list.component';
import { AffectedAreasListComponent } from './modals/affected-areas-list/affected-areas-list.component';

@Component({
  selector: 'lib-risk-template-access',
  templateUrl: './risk-template-access.component.html',
  styleUrls: ['./risk-template-access.component.scss']
})
export class RiskTemplateAccessComponent implements OnInit {
  isLoading = true;
  accessList: Array<TemplateAccess> = [];
  confirmationDynamicDialogRef: DynamicDialogRef;

  constructor(
    private dialogService: DialogService,
    private messageService: AgilityRiskMessageService,
    private translateService: TranslateService,
    private riskService: AgilityRiskService,
    private spinner: AgilityRiskSpinnerService) {
  }

  ngOnInit(): void {
    this.getManagerAccessList();
  }

  getManagerAccessList() {
    this.isLoading = true;
    this.riskService.getManagerAccessList().subscribe({
      next: managers => {
        this.accessList = managers;
        this.isLoading = false;
      },
      error: _ => {
        this.isLoading = false;
      }
    });
  }

  deleteManager(managerId: string) {
    this.confirmationDynamicDialogRef = this.dialogService.open(ConfirmationModalComponent, {
      data: {
        body: this.translateService.instant('riskTemplates.manageAccess.deleteManagerBody')
      },
      header: this.translateService.instant('riskTemplates.manageAccess.deleteManager'),
      width: '35%'
    });

    this.confirmationDynamicDialogRef.onClose.subscribe((result: any) => {
      if (result) {
        this.spinner.start();
        this.riskService.deleteManagerAccess(managerId).subscribe({
          next: () => {
            this.accessList = this.accessList.filter(el => el.id !== managerId);
            this.messageService.success(this.translateService.instant('common.success'), this.translateService.instant('riskTemplates.manageAccess.managerDeleteSuccessfully'));
            this.spinner.stop();
          },
          error: () => {
            this.messageService.error(this.translateService.instant('common.error'), this.translateService.instant('riskTemplates.manageAccess.managerDeleteUnSuccessfully'));
            this.spinner.stop();
          }
        });
      }
    });
  }

  hasAffectedAreasAssociated(templateAccess: TemplateAccess): boolean {
    const hasAnyAll = templateAccess.allDepartments ||
                      templateAccess.allResources ||
                      templateAccess.allVendors ||
                      templateAccess.allSites;
    const areas = [
      ...templateAccess.riskAffectedDepartments,
      ...templateAccess.riskAffectedResources,
      ...templateAccess.riskAffectedVendors,
      ...templateAccess.riskAffectedSites
    ];
    return hasAnyAll || !!areas.length;
  }

  showListOfTemplates(templateAccess: TemplateAccess): void {
    this.dialogService.open(RiskTemplatesListComponent, {
      header: this.translateService.instant('riskTemplates.riskTemplates'),
      width: '500px',
      data: { riskTemplates: templateAccess.riskTemplates }
    });
  }

  showListOfAffectedAreas(templateAccess: TemplateAccess): void {
    this.dialogService.open(AffectedAreasListComponent, {
      header: this.translateService.instant('riskTemplates.manageAccess.thirdParties'),
      width: '60%',
      data: { templateAccess }
    });
  }
}
